import { render, staticRenderFns } from "./MailRecord.vue?vue&type=template&id=47a6b39b&scoped=true&"
import script from "./MailRecord.vue?vue&type=script&lang=js&"
export * from "./MailRecord.vue?vue&type=script&lang=js&"
import style0 from "./MailRecord.vue?vue&type=style&index=0&id=47a6b39b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6b39b",
  null
  
)

export default component.exports